import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import { layout } from '../styles';
var StyledButtonGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbutton + button {\n\t\tmargin-left: ", ";\n\t}\n"])), layout.smallSpace);
/** Adds default padding between buttons */
export function ButtonGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledButtonGroup, null, children);
}